const merge = (objFrom, objTo) =>
  Object.keys(objFrom).reduce(
    (merged, key) => {
      merged[key] =
        objFrom[key] instanceof Object && !Array.isArray(objFrom[key])
          ? merge(objFrom[key], merged[key] || {})
          : objFrom[key];
      return merged;
    },
    { ...objTo }
  );

export default merge;
